import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";

const SiteAndRegionTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrderStatus = { props };
  return (
    <>
      <span className="fw-bold">
        {workOrderStatus.props.hwrcSiteName}
      </span>
      <br />
      <span>
        {workOrderStatus.props.regionName}
      </span>
    </>
  );
};
export default SiteAndRegionTemplate;
